import { Main } from './components';

const ReadyToPrepareByHour = () => <Main />;

export default ReadyToPrepareByHour;
